import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getOrCreateSession, handleTapClick } from '../utils/engagement';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Logs each page view and every phone / WhatsApp tap.
export default function VisitorTracker() {
  const location = useLocation();

  useEffect(() => {
    document.addEventListener('click', handleTapClick, true);
    return () => document.removeEventListener('click', handleTapClick, true);
  }, []);

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    if (!API_URL) return;
    fetch(`${API_URL}/api/visitor/ping`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        path: location.pathname + (location.search || ''),
        referrer: document.referrer || '',
        user_agent: navigator.userAgent || '',
        session_id: getOrCreateSession(),
      }),
      keepalive: true,
    }).catch(() => {});
  }, [location.pathname, location.search]);

  return null;
}
